import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Icon } from "../icon/Icon";

const OutlinedChecked = (props) => {
  return (
    <ul
      className={["list", props.className ? props.className : null].join(" ")}
    >
      {props.data.map((data, index) => (
        <li key={index}>{data}</li>
      ))}
    </ul>
  );
};

const CheckedCircle = (props) => {
  return (
    <ul
    //   className={["list", props.className ? props.className : null].join(" ")}
    >
      {props.data.map((data, index) => (
        <>
          <li className="pb-2" key={index}>
            {/* <Icon name="check-circle" className={["list", props.className ? props.className : null].join(" ")} iconType="fa" color="#42b490" /> */}
            <span className={["badge badge-dot badge-md badge-primary", props.className ? props.className : null].join(" ")}> </span>
            <span className={props.className}>{data}</span>
          </li>
        </>
      ))}
    </ul>
  );
};

const ListChecked = (props) => {
  return (
    <ul
      className={["list", props.className ? props.className : null].join(" ")}
    >
      {props.data.map((data, index) => (
        <li key={index}>
          <strong>{data}</strong>
        </li>
      ))}
    </ul>
  );
};

const LinkInline = (props) => {
  return (
    <ul
      className={["link-inline", props.className ? props.className : null].join(
        " "
      )}
    >
      {props.data.map((data, index) => (
        <li key={index}>
          <a href={data.to} onClick={(ev) => ev.preventDefault()}>
            {data.text}
          </a>
        </li>
      ))}
    </ul>
  );
};

export { OutlinedChecked, LinkInline, CheckedCircle, ListChecked };
